import React, { useState } from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import poster from "../../assets/images/poster.png";
import edit_pencil_icon from "../../assets/icons/edit_pencil_icon.png";
import copy_icon from "../../assets/icons/copy_icon.png";
import download_icon from "../../assets/icons/download_icon.png";
import share_icon from "../../assets/icons/share_icon.png";
import copyLink_icon from "../../assets/icons/copyLink_icon.png";
import delete_icon from "../../assets/icons/delete_icon.png";
import design_icon from "../../assets/icons/design_icon.png";
import Aa from "../../assets/icons/Aa_icon.png";
import upload_icon from "../../assets/icons/upload_icon.png";
import backandfront_icon from "../../assets/icons/backandfront_icon.png";
import instagram_logo from "../../assets/images/instagram_logo.png";
import facebook_logo from "../../assets/images/facebook_logo.png";
import x_logo from "../../assets/images/x_logo.png";
import linkedin_logo from "../../assets/images/linkedin_logo.png";
import whatsapp_logo from "../../assets/images/whatsapp_logo.png";
import copy_link_logo from "../../assets/images/copy_link_logo.png";

const PosterTemplate = ({ setPosterTemplate }) => {
  const [edit, setEdit] = useState(false);
  const [design, setDesign] = useState(false);
  const [text, setText] = useState(false);
  const [share, setShare] = useState(false);

  const handleDesign = () => {
    setText(false);
    setShare(false);
    setDesign(true);
  };

  const handleText = () => {
    setDesign(false);
    setShare(false);
    setText(true);
  };

  const handleShare = () => {
    setDesign(false);
    setText(false);
    setShare(true);
  };

  return (
    <>
      <div className={`modal-wrapper overflow-y-auto`}>
        <div
          className={`side-modal w-[40%] ${
            design || text || share ? "" : "h-full"
          }`}
        >
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[70%] justify-end">
              <div
                onClick={() => setPosterTemplate(false)}
                className="cursor-pointer"
              >
                <img src={cross_icon} alt="cross icon" />
              </div>
            </div>
          </div>
          {edit ? (
            <div className="ml-4">
              <img
                src={backandfront_icon}
                alt="back and front"
                className="w-20"
              />
            </div>
          ) : null}
          <div className="ml-4 flex justify-center items-center">
            <img src={poster} alt="poster" className="w-[40%]" />
          </div>
          {!edit ? (
            <div>
              <div className="w-[80%]  ml-8">
                <div className="flex justify-between items-center mt-4">
                  <p className="text-[20px] font-bold">
                    New Collection Poster{" "}
                  </p>
                  <img
                    src={edit_pencil_icon}
                    className="object-contain w-4"
                    alt="edit pencil"
                  />
                </div>

                <p className="text-[16px] text-[#828282] mt-2">
                  Poster • Edited 37 minutes age
                </p>
              </div>

              <div className="flex justify-center mt-4 mb-8">
                <div className="w-[90%]">
                  <hr />
                </div>
              </div>

              <div className="mt-4 ml-8 text-[16px]">
                <div
                  className="flex mt-2 cursor-pointer"
                  onClick={() => setEdit(true)}
                >
                  <img
                    src={edit_pencil_icon}
                    alt="pencil"
                    className="object-contain w-3 mr-2"
                  />
                  <p>Edit design</p>
                </div>
                <div className="flex mt-4">
                  <img
                    src={copy_icon}
                    alt="pencil"
                    className="object-contain w-3 mr-2"
                  />
                  <p>Make a copy</p>
                </div>
                <div className="flex mt-4">
                  <img
                    src={download_icon}
                    alt="pencil"
                    className="object-contain w-3 mr-2"
                  />
                  <p>Download</p>
                </div>
                <div className="flex mt-4">
                  <img
                    src={share_icon}
                    alt="pencil"
                    className="object-contain w-3 mr-2"
                  />
                  <p>Share</p>
                </div>
                <div className="flex mt-4">
                  <img
                    src={copyLink_icon}
                    alt="pencil"
                    className="object-contain w-3 mr-2"
                  />
                  <p>Copy Link</p>
                </div>
                <div className="flex mt-4">
                  <img
                    src={delete_icon}
                    alt="pencil"
                    className="object-contain w-3 mr-2"
                  />
                  <p>Move to trash</p>
                </div>
              </div>
            </div>
          ) : null}
          {edit ? (
            <div className="bg-[#F4F9FF] py-2 flex fixed bottom-0 justify-around items-center w-[40%] social-width">
              <div
                className=" flex flex-col justify-center items-center  cursor-pointer"
                onClick={handleDesign}
              >
                <img
                  src={design_icon}
                  alt="design"
                  className="object-contain w-5"
                />
                <p className="text-[12px] mt-1">Designs</p>
              </div>
              <div
                className="flex flex-col justify-center items-center  cursor-pointer"
                onClick={handleText}
              >
                <img src={Aa} alt="Aa" className="object-contain w-5" />
                <p className="text-[12px] mt-1">Text</p>
              </div>
              <div className="flex flex-col justify-center items-center  cursor-pointer">
                <img
                  src={upload_icon}
                  alt="upload"
                  className="object-contain w-5"
                />
                <p className="text-[12px] mt-1">Upload</p>
              </div>
              <div
                className="flex flex-col justify-center items-center  cursor-pointer"
                onClick={handleShare}
              >
                <img
                  src={share_icon}
                  alt="share"
                  className="object-contain w-5"
                />
                <p className="text-[12px] mt-1">Share</p>
              </div>
            </div>
          ) : null}

          {/* Design */}

          {design ? (
            <div className="ml-4 mb-32">
              <p className="text-[20px] font-bold ">Designs</p>
              <div className="flex justify-center mt-4">
                <div className="w-[90%]">
                  <hr />
                </div>
              </div>

              <div className="flex justify-center flex-wrap">
                <img
                  src={poster}
                  className="w-32 object-contain mr-8 mt-4 cursor-pointer"
                  alt="poster"
                />
                <img
                  src={poster}
                  className="w-32 object-contain mr-8 mt-4 cursor-pointer"
                  alt="poster"
                />
                <img
                  src={poster}
                  className="w-32 object-contain mr-8 mt-4 cursor-pointer"
                  alt="poster"
                />
              </div>
              <div className="flex justify-center flex-wrap">
                <img
                  src={poster}
                  className="w-32 object-contain mr-8 mt-4 cursor-pointer"
                  alt="poster"
                />
                <img
                  src={poster}
                  className="w-32 object-contain mr-8 mt-4 cursor-pointer"
                  alt="poster"
                />
                <img
                  src={poster}
                  className="w-32 object-contain mr-8 mt-4 cursor-pointer"
                  alt="poster"
                />
              </div>
            </div>
          ) : null}

          {/* Text */}

          {text ? (
            <div className="ml-4 mb-32">
              <p className="text-[20px] font-bold ">Text</p>
              <div className="flex justify-center mt-4">
                <div className="w-[90%]">
                  <hr />
                </div>
              </div>

              <div className="w-full justify-center">
                <div className="flex justify-between items-center w-[90%] flex--cards">
                  <div className="mt-4 w-[40%] card--one">
                    <p className="text-[12px] text-[#828282]">Heading text</p>
                    <input
                      type="text"
                      value="New Collection"
                      className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                    />
                  </div>
                  <p className="text-[#828282] text-[12px] mt-8">change to</p>
                  <div className="mt-4 w-[40%] card--one">
                    <p className="text-[12px] text-[#828282]">Heading text</p>
                    <input
                      type="text"
                      placeholder="Enter the text here"
                      className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center w-[90%] flex--cards">
                  <div className="mt-4 w-[40%] card--one">
                    <p className="text-[12px] text-[#828282]">Body text</p>
                    <input
                      type="text"
                      value="Coming Soon"
                      className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                    />
                  </div>
                  <p className="text-[#828282] text-[12px] mt-8">change to</p>
                  <div className="mt-4 w-[40%] card--one">
                    <p className="text-[12px] text-[#828282]">Body text</p>
                    <input
                      type="text"
                      placeholder="Enter the text here"
                      className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center w-[90%] flex--cards">
                  <div className="mt-4 w-[40%] card--one">
                    <p className="text-[12px] text-[#828282]">Footer text</p>
                    <input
                      type="text"
                      value="Stay Tuned"
                      className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                    />
                  </div>
                  <p className="text-[#828282] text-[12px] mt-8">change to</p>
                  <div className="mt-4 w-[40%] card--one">
                    <p className="text-[12px] text-[#828282]">Footer text</p>
                    <input
                      type="text"
                      placeholder="Enter the text here"
                      className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-center mt-8 w-[90%]">
                <button className="bg-[#2F80ED] text-[14px] text-white py-2 px-10 rounded-lg">
                  Add a text box
                </button>
              </div>
            </div>
          ) : null}

          {/* Share */}

          {share ? (
            <div className="ml-4 h-screen">
              <p className="text-[20px] font-bold ">Share Post</p>
              <div className="flex justify-center mt-4">
                <div className="w-[90%]">
                  <hr />
                </div>
              </div>

              <div className="flex flex-col mt-8 w-[70%] text-[14px] share--icons">
                <div className="flex justify-between ml-4 flex-wrap share">
                  <div className="flex flex-col items-center">
                    <img
                      src={facebook_logo}
                      alt="facebook"
                      className="w-10 object-contain mb-1"
                    />
                    <p>Facebook</p>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src={instagram_logo}
                      alt="Instagram"
                      className="w-10 object-contain mb-1"
                    />
                    <p>Instagram</p>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src={x_logo}
                      alt="Twitter"
                      className="w-10 object-contain mb-1"
                    />
                    <p>Twitter</p>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src={linkedin_logo}
                      alt="Linkedin"
                      className="w-10 object-contain mb-1"
                    />
                    <p>Linkedin</p>
                  </div>
                </div>
                <div className="flex mt-8 w-[50%] ml-4 card--one share">
                  <div className="flex flex-col items-center mr-16">
                    <img
                      src={whatsapp_logo}
                      alt="Whatsapp"
                      className="w-10 object-contain mb-1"
                    />
                    <p>Whatsapp</p>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src={copy_link_logo}
                      alt="Copy Link"
                      className="w-10 object-contain mb-1"
                    />
                    <p>Copy Link</p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default PosterTemplate;
